export enum StatusAudiencia {
    Designada = 1,
    Realizada = 2,
    Redesignada = 3,
    Cancelada = 4
}